import { Tool } from "./Tool";
export class Location {
  locationName: string;
  locationDescription: string;
  tools: Tool[];
  expanded: boolean;
}
